import type { PropertyContract } from "@/hooks/useContracts";

/**
 * Determines if a contract is operationally active at a given reference date.
 * - Active contracts are always considered active.
 * - Cancelled contracts are active only if cancelled_at is in the future relative to referenceDate.
 * - Legacy cancelled contracts (no cancelled_at) are treated as fully inactive.
 */
export const isContractActive = (
  contract: { status: string; cancelled_at?: string | null },
  referenceDate: Date = new Date(),
): boolean => {
  if (contract.status === "active") return true;
  if (
    contract.status === "cancelled" &&
    contract.cancelled_at
  ) {
    return new Date(contract.cancelled_at + "T23:59:59") > referenceDate;
  }
  return false;
};

/**
 * Filters an array of contracts to only those operationally active.
 */
export const filterActiveContracts = <T extends { status: string; cancelled_at?: string | null }>(
  contracts: T[],
  referenceDate: Date = new Date(),
): T[] => contracts.filter((c) => isContractActive(c, referenceDate));
